import {
  createPlugin,
  createRoutableExtension,
  createApiFactory,
  discoveryApiRef,
  fetchApiRef,
} from '@backstage/core-plugin-api';

import { rootRouteRef } from './routes';
import { githubSecretsApiRef, GithubSecretsClient } from './api';

export const githubSecretsPlugin = createPlugin({
  id: 'github-secrets',
  routes: {
    root: rootRouteRef,
  },
  apis: [
    createApiFactory({
      api: githubSecretsApiRef,
      deps: { discoveryApi: discoveryApiRef, fetchApi: fetchApiRef },
      factory: ({ discoveryApi, fetchApi }) =>
        new GithubSecretsClient({ discoveryApi, fetchApi }),
    }),
  ],
});

export const EntityGithubSecretsContent = githubSecretsPlugin.provide(
  createRoutableExtension({
    name: 'EntityGithubSecretsContent',
    component: () =>
      import('./components/GithubSecretsContent').then(m => m.GithubSecretsContent),
    mountPoint: rootRouteRef,
  }),
);
